import { ThemeProvider } from '@mui/material';
import { theme } from './styles/theme';
import HomePage from './components/exactera/home-page';
import { HashRouter } from 'react-router';
import { getAppConfig } from './utils/configuration';
import { reactPlugin } from '@datadog/browser-rum-react';
import { datadogRum } from '@datadog/browser-rum';
import { decodeTokens, getAuthInfo } from './utils/auth';

function App() {

  const { dataDogRumConfig, itpUrl, xbsEnvironment } = getAppConfig();
  const { authToken } = getAuthInfo();
  const userData = decodeTokens(authToken);

  datadogRum.init({
    applicationId: dataDogRumConfig[xbsEnvironment].applicationId,
    clientToken: dataDogRumConfig[xbsEnvironment].clientToken,
    site: 'datadoghq.com',
    service: 'itp-word-add-in',
    env: xbsEnvironment,
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    defaultPrivacyLevel: 'allow',
    plugins: [reactPlugin({ router: true })],
    enableExperimentalFeatures: ['feature_flags'],
    silentMultipleInit: true,
    allowedTracingUrls: [itpUrl],
    trackUserInteractions: true,
    trackResources: true,
    sessionPersistence: 'local-storage',
  });

  datadogRum.setUser({
    id: userData.userId ?? 'anonymous',
    email: userData.email ?? undefined,
  });

  return (
    <ThemeProvider theme={theme}>
      <HashRouter>
        <HomePage />
      </HashRouter>
    </ThemeProvider>
  );

}

export default App;